/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { fDate, fDateTimeSuffix } from "../../Utils/Date_formet";

const Notification = ({ status, NotificationData  }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  
  const handleLinkClick = () => {
    setIsOpen(false);
  };

 
  const show_Name = (item) => {
    if (item) {
      return item
        .split("_")
        .map((part) => part[0])
        .join("")
        .toUpperCase();
    }
    return "A";
  };


  const notificationCount = NotificationData?.data?.length || 0;

  return (
    <div>
      <li
        ref={dropdownRef}
        className="nav-item dropdown notification_dropdown position-relative"
      >
        {/* Notification Bell Button */}
        <button
          className="header-btn btn"
          role="button"
          onClick={toggleDropdown}
          aria-expanded={isOpen}
          style={{
            border: "none",
            background: "transparent",
            padding: "8px 12px",
            borderRadius: "6px",
            transition: "all 0.2s ease",
            position: "relative",
          }}
          title="Notifications"
        >
          <i
            className="fa fa-bell"
            style={{
              fontSize: "18px",
              color: notificationCount > 0 ? "#007bff" : "inherit"
            }}
          />

          {/* Notification Badge */}
          {notificationCount > 0 && (
            <span
              className="badge bg-primary rounded-circle position-absolute"
              style={{
                top: "2px",
                right: "6px",
                minWidth: "18px",
                height: "18px",
                fontSize: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                animation: notificationCount > 0 ? "pulse 2s infinite" : "none",
              }}
            >
              {notificationCount > 99 ? "99+" : notificationCount}
            </span>
          )}
        </button>

        {/* Dropdown Menu */}
        <div
          className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}
          style={{
            position: "absolute",
            top: "100%",
            right: "0",
            margin: "8px 0 0 0",
            padding: "0",
            minWidth: "320px",
            maxWidth: "400px",
            maxHeight: "500px",
            backgroundColor: "var(--bs-dropdown-bg, #ffffff)",
            border: "1px solid var(--bs-border-color, #e1e7ef)",
            borderRadius: "8px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
            zIndex: 1050,
            transform: isOpen ? "translateY(0) scale(1)" : "translateY(-10px) scale(0.95)",
            opacity: isOpen ? 1 : 0,
            visibility: isOpen ? "visible" : "hidden",
            transition: "all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1)",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "15px 20px",
              borderBottom: "1px solid #e9ecef",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <h6
              style={{
                margin: "0",
                fontSize: "16px",
                fontWeight: "600",
                color: "#495057",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Notifications</span>
              {notificationCount > 0 && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    backgroundColor: "#e9ecef",
                    padding: "2px 8px",
                    borderRadius: "12px",
                  }}
                >
                  {notificationCount} new
                </span>
              )}
            </h6>
          </div>

          {/* Notifications List */}
          <div
            id="DZ_W_Notification1"
            className="widget-media dz-scroll"
            style={{
              maxHeight: "350px",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            {notificationCount > 0 ? (
              <ul className="timeline" style={{ listStyle: "none", padding: "0", margin: "0" }}>
                {NotificationData?.data.slice(0, 6)?.map((item, index) => {
                  return status == 2 ? (
                    // User Notifications (Status 2)
                    <li
                      key={item.id || index}
                      style={{
                        marginBottom: '12px',
                        animation: `slideInRight 0.3s ease ${index * 0.1}s both`
                      }}
                    >
                      <div style={{
                        padding: '12px 15px',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid #e9ecef',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                      }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                          e.currentTarget.style.transform = 'translateX(2px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#fff';
                          e.currentTarget.style.transform = 'translateX(0)';
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                          {/* Avatar */}
                          <div style={{ flexShrink: 0 }}>
                            <span style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              fontSize: '12px',
                              fontWeight: '600',
                              backgroundColor: '#007bff',
                              color: '#fff',
                              boxShadow: '0 2px 4px rgba(0, 123, 255, 0.3)',
                            }}>
                              {show_Name(item.fullname)}
                            </span>
                          </div>

                          {/* Content */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ marginBottom: '4px' }}>
                              <h6 style={{
                                margin: '0',
                                fontSize: '13px',
                                fontWeight: '600',
                                color: '#007bff',
                                lineHeight: '1.3',
                              }}>
                                Received From Admin
                              </h6>
                            </div>

                            <p style={{
                              margin: '0 0 6px 0',
                              fontSize: '12px',
                              color: '#6c757d',
                              lineHeight: '1.4',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}>
                              {item.Message}
                            </p>

                            <small style={{
                              fontSize: '11px',
                              color: '#adb5bd',
                              fontWeight: '500',
                            }}>
                              {fDateTimeSuffix(item?.createdAt)}
                            </small>
                          </div>
                        </div>
                      </div>
                    </li>
                  ) : (
                    // Admin Notifications (Status 1)
                    <li
                      key={item.id || index}
                      style={{
                        marginBottom: '10px',
                        animation: `slideInRight 0.3s ease ${index * 0.1}s both`
                      }}
                    >
                      <div
                        className="timeline-panel"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 15px',
                          backgroundColor: '#fff',
                          border: '1px solid #e9ecef',
                          borderRadius: '6px',
                          transition: 'all 0.2s ease',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                          e.currentTarget.style.transform = 'translateX(2px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#fff';
                          e.currentTarget.style.transform = 'translateX(0)';
                        }}
                      >
                        <div
                          className="media me-3"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: '#17a2b8',
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: '600',
                            flexShrink: 0,
                          }}
                        >
                          {show_Name(item.fullname)}
                        </div>
                        <div className="media-body" style={{ minWidth: 0 }}>
                          <h6
                            className="mb-1"
                            style={{
                              fontSize: '13px',
                              fontWeight: '600',
                              color: '#495057',
                              margin: '0 0 2px 0',
                              lineHeight: '1.2',
                            }}
                          >
                            Received From {item.username}
                          </h6>
                          <small
                            className="d-block"
                            style={{
                              fontSize: '11px',
                              color: '#6c757d',
                              fontWeight: '500',
                            }}
                          >
                            {fDateTimeSuffix(item?.createdAt)}
                          </small>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              // Empty State
              <div
                style={{
                  textAlign: 'center',
                  padding: '40px 20px',
                  color: '#6c757d',
                }}
              >
                <i
                  className="fa fa-bell-slash"
                  style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.3 }}
                />
                <p style={{ margin: '0', fontSize: '14px' }}>
                  No new notifications
                </p>
              </div>
            )}
          </div>

          {/* Footer - See All Link */}
          {notificationCount > 0 && (
            <div style={{ borderTop: "1px solid #e9ecef" }}>
              {status == 2 ? (
                <Link
                  to="/client/helpcenter"
                  state={{ status: 2 }}
                  className="all-notification"
                  onClick={handleLinkClick}
                  style={{
                    display: 'block',
                    padding: '12px 20px',
                    textAlign: 'center',
                    color: '#007bff',
                    textDecoration: 'none',
                    fontSize: '13px',
                    fontWeight: '600',
                    borderRadius: '0 0 8px 8px',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                    e.currentTarget.style.color = '#0056b3';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#007bff';
                  }}
                >
                  See all notifications <i className="ti-arrow-end ms-1" />
                </Link>
              ) : (
                <Link
                  to="/admin/helpcenter"
                  className="all-notification"
                  onClick={handleLinkClick}
                  style={{
                    display: 'block',
                    padding: '12px 20px',
                    textAlign: 'center',
                    color: '#007bff',
                    textDecoration: 'none',
                    fontSize: '13px',
                    fontWeight: '600',
                    borderRadius: '0 0 8px 8px',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                    e.currentTarget.style.color = '#0056b3';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#007bff';
                  }}
                >
                  See all notifications <i className="ti-arrow-end ms-1" />
                </Link>
              )}
            </div>
          )}
        </div>
      </li>

      {/* Custom CSS for animations */}
      <style >{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .header-btn:hover {
          background-color: var(--bs-gray-100, #f8f9fa) !important;
        }

        .dz-scroll::-webkit-scrollbar {
          width: 4px;
        }

        .dz-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 2px;
        }

        .dz-scroll::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 2px;
        }

        .dz-scroll::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }

        @media (max-width: 768px) {
          .dropdown-menu {
            min-width: 280px !important;
            left: auto !important;
            right: 0 !important;
          }
        }

        @media (max-width: 480px) {
          .dropdown-menu {
            min-width: 260px !important;
            margin-right: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default Notification;